/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiLoadSpinnerIcon20Solid = forwardRef('UiLoadSpinnerIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 4.001a5.999 5.999 0 1 0 5.999 6 1.25 1.25 0 0 1 2.5 0A8.499 8.499 0 1 1 10 1.5a1.25 1.25 0 1 1 0 2.5Z" })));
});
